module.exports = __webpack_public_path__ + "static/georg-0f63ec788f956f7560db1f03e61b7754.png";